/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum SitePermissionType {
  ANONYMOUS = "ANONYMOUS",
  APP = "APP",
  EXTERNAL = "EXTERNAL",
  INTERNAL = "INTERNAL",
  JSD = "JSD",
}

//==============================================================
// END Enums and Input Objects
//==============================================================

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ShareAndRestrictDialogQuery
// ====================================================

export interface ShareAndRestrictDialogQuery_content_nodes_ancestors_links {
  webui: string | null;
}

export interface ShareAndRestrictDialogQuery_content_nodes_ancestors {
  id: string | null;
  hasViewRestrictions: boolean;
  links: ShareAndRestrictDialogQuery_content_nodes_ancestors_links | null;
}

export interface ShareAndRestrictDialogQuery_content_nodes_operations {
  operation: string | null;
  targetType: string | null;
}

export interface ShareAndRestrictDialogQuery_content_nodes_restrictions_read_restrictions_userWithRestrictions_nodes_profilePicture {
  path: string;
}

export interface ShareAndRestrictDialogQuery_content_nodes_restrictions_read_restrictions_userWithRestrictions_nodes_restrictingContent_links {
  webui: string | null;
  base: string | null;
}

export interface ShareAndRestrictDialogQuery_content_nodes_restrictions_read_restrictions_userWithRestrictions_nodes_restrictingContent {
  id: string | null;
  links: ShareAndRestrictDialogQuery_content_nodes_restrictions_read_restrictions_userWithRestrictions_nodes_restrictingContent_links | null;
}

export interface ShareAndRestrictDialogQuery_content_nodes_restrictions_read_restrictions_userWithRestrictions_nodes {
  type: string | null;
  displayName: string | null;
  email: string | null;
  accountId: string | null;
  profilePicture: ShareAndRestrictDialogQuery_content_nodes_restrictions_read_restrictions_userWithRestrictions_nodes_profilePicture | null;
  hasSpaceViewPermission: boolean | null;
  hasSpaceEditPermission: boolean | null;
  permissionType: SitePermissionType | null;
  restrictingContent: ShareAndRestrictDialogQuery_content_nodes_restrictions_read_restrictions_userWithRestrictions_nodes_restrictingContent | null;
}

export interface ShareAndRestrictDialogQuery_content_nodes_restrictions_read_restrictions_userWithRestrictions_pageInfo {
  hasNextPage: boolean | null;
  endCursor: string | null;
}

export interface ShareAndRestrictDialogQuery_content_nodes_restrictions_read_restrictions_userWithRestrictions {
  count: number | null;
  nodes: (ShareAndRestrictDialogQuery_content_nodes_restrictions_read_restrictions_userWithRestrictions_nodes | null)[] | null;
  pageInfo: ShareAndRestrictDialogQuery_content_nodes_restrictions_read_restrictions_userWithRestrictions_pageInfo | null;
}

export interface ShareAndRestrictDialogQuery_content_nodes_restrictions_read_restrictions_group_nodes {
  id: string | null;
  name: string | null;
  permissionType: SitePermissionType | null;
}

export interface ShareAndRestrictDialogQuery_content_nodes_restrictions_read_restrictions_group_pageInfo {
  hasNextPage: boolean | null;
  endCursor: string | null;
}

export interface ShareAndRestrictDialogQuery_content_nodes_restrictions_read_restrictions_group {
  count: number | null;
  nodes: (ShareAndRestrictDialogQuery_content_nodes_restrictions_read_restrictions_group_nodes | null)[] | null;
  pageInfo: ShareAndRestrictDialogQuery_content_nodes_restrictions_read_restrictions_group_pageInfo | null;
}

export interface ShareAndRestrictDialogQuery_content_nodes_restrictions_read_restrictions {
  userWithRestrictions: ShareAndRestrictDialogQuery_content_nodes_restrictions_read_restrictions_userWithRestrictions | null;
  group: ShareAndRestrictDialogQuery_content_nodes_restrictions_read_restrictions_group | null;
}

export interface ShareAndRestrictDialogQuery_content_nodes_restrictions_read {
  restrictions: ShareAndRestrictDialogQuery_content_nodes_restrictions_read_restrictions | null;
}

export interface ShareAndRestrictDialogQuery_content_nodes_restrictions_update_restrictions_userWithRestrictions_nodes_profilePicture {
  path: string;
}

export interface ShareAndRestrictDialogQuery_content_nodes_restrictions_update_restrictions_userWithRestrictions_nodes_restrictingContent_links {
  webui: string | null;
  base: string | null;
}

export interface ShareAndRestrictDialogQuery_content_nodes_restrictions_update_restrictions_userWithRestrictions_nodes_restrictingContent {
  id: string | null;
  links: ShareAndRestrictDialogQuery_content_nodes_restrictions_update_restrictions_userWithRestrictions_nodes_restrictingContent_links | null;
}

export interface ShareAndRestrictDialogQuery_content_nodes_restrictions_update_restrictions_userWithRestrictions_nodes {
  type: string | null;
  displayName: string | null;
  email: string | null;
  accountId: string | null;
  profilePicture: ShareAndRestrictDialogQuery_content_nodes_restrictions_update_restrictions_userWithRestrictions_nodes_profilePicture | null;
  hasSpaceViewPermission: boolean | null;
  hasSpaceEditPermission: boolean | null;
  permissionType: SitePermissionType | null;
  restrictingContent: ShareAndRestrictDialogQuery_content_nodes_restrictions_update_restrictions_userWithRestrictions_nodes_restrictingContent | null;
}

export interface ShareAndRestrictDialogQuery_content_nodes_restrictions_update_restrictions_userWithRestrictions_pageInfo {
  hasNextPage: boolean | null;
  endCursor: string | null;
}

export interface ShareAndRestrictDialogQuery_content_nodes_restrictions_update_restrictions_userWithRestrictions {
  count: number | null;
  nodes: (ShareAndRestrictDialogQuery_content_nodes_restrictions_update_restrictions_userWithRestrictions_nodes | null)[] | null;
  pageInfo: ShareAndRestrictDialogQuery_content_nodes_restrictions_update_restrictions_userWithRestrictions_pageInfo | null;
}

export interface ShareAndRestrictDialogQuery_content_nodes_restrictions_update_restrictions_group_nodes {
  id: string | null;
  name: string | null;
  permissionType: SitePermissionType | null;
}

export interface ShareAndRestrictDialogQuery_content_nodes_restrictions_update_restrictions_group_pageInfo {
  hasNextPage: boolean | null;
  endCursor: string | null;
}

export interface ShareAndRestrictDialogQuery_content_nodes_restrictions_update_restrictions_group {
  count: number | null;
  nodes: (ShareAndRestrictDialogQuery_content_nodes_restrictions_update_restrictions_group_nodes | null)[] | null;
  pageInfo: ShareAndRestrictDialogQuery_content_nodes_restrictions_update_restrictions_group_pageInfo | null;
}

export interface ShareAndRestrictDialogQuery_content_nodes_restrictions_update_restrictions {
  userWithRestrictions: ShareAndRestrictDialogQuery_content_nodes_restrictions_update_restrictions_userWithRestrictions | null;
  group: ShareAndRestrictDialogQuery_content_nodes_restrictions_update_restrictions_group | null;
}

export interface ShareAndRestrictDialogQuery_content_nodes_restrictions_update {
  restrictions: ShareAndRestrictDialogQuery_content_nodes_restrictions_update_restrictions | null;
}

export interface ShareAndRestrictDialogQuery_content_nodes_restrictions {
  read: ShareAndRestrictDialogQuery_content_nodes_restrictions_read | null;
  update: ShareAndRestrictDialogQuery_content_nodes_restrictions_update | null;
}

export interface ShareAndRestrictDialogQuery_content_nodes {
  id: string | null;
  ancestors: (ShareAndRestrictDialogQuery_content_nodes_ancestors | null)[] | null;
  hasInheritedRestrictions: boolean;
  operations: (ShareAndRestrictDialogQuery_content_nodes_operations | null)[] | null;
  restrictions: ShareAndRestrictDialogQuery_content_nodes_restrictions | null;
}

export interface ShareAndRestrictDialogQuery_content {
  nodes: (ShareAndRestrictDialogQuery_content_nodes | null)[] | null;
}

export interface ShareAndRestrictDialogQuery_user_emails {
  value: string | null;
  isPrimary: boolean | null;
}

export interface ShareAndRestrictDialogQuery_user_photos {
  value: string | null;
  isPrimary: boolean | null;
}

export interface ShareAndRestrictDialogQuery_user {
  id: string | null;
  displayName: string | null;
  emails: (ShareAndRestrictDialogQuery_user_emails | null)[] | null;
  photos: (ShareAndRestrictDialogQuery_user_photos | null)[] | null;
}

export interface ShareAndRestrictDialogQuery_space_currentUser {
  isAdmin: boolean;
}

export interface ShareAndRestrictDialogQuery_space {
  id: string | null;
  currentUser: ShareAndRestrictDialogQuery_space_currentUser;
}

export interface ShareAndRestrictDialogQuery {
  content: ShareAndRestrictDialogQuery_content | null;
  user: ShareAndRestrictDialogQuery_user | null;
  space: ShareAndRestrictDialogQuery_space | null;
}

export interface ShareAndRestrictDialogQueryVariables {
  contentId: string;
  status?: (string | null)[] | null;
  draftShareId?: string | null;
  spaceKey: string;
}
